import { AttachmentButton, ChatContainer, ConversationHeader, MessageInput, MessageList } from '@chatscope/chat-ui-kit-react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { IconButton, Link, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { createRef, useCallback, useEffect, useMemo, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { sendMessageSupportChat } from 'services/chat.services';
import { chatAttachmentState, chatChannelState } from 'pages/CustomerBooking';
import { MessageContent } from './MessageContent';
import { useStyles } from './styles';

import { makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { bookingState } from '../RecoilState';

import { deviceData } from '@zennya/web-component-library/src/components/Device'
import { isEmpty } from 'lodash';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import moment from "moment-timezone";
import { parseBookingStatus } from 'util/bookingStates';
import { useTrackEvent } from 'util/trackEvent';
import { useBranch } from '@zennya/web-component-library/src';
import { TextField } from "@material-ui/core";
import useDocumentHeight from 'util/useDocumentHeight';
const baseStyles = makeStyles((theme) => {
  return {
    conversationBannerAd: {
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.secondary.contrastText,
    },
    bannerAdLink: {
      fontWeight: 'bold',
    }
  }
})


export { }
const SupportChat = ({ appBar, source, isAnonymous = false, fingerprint, messageList, reloadMessages = () => { } }) => {
  const routeMatch = useRouteMatch()
  const location = useLocation()
  const history = useHistory()
  const booking = useRecoilValue(bookingState)
  const chatAttachment = useRecoilValue(chatAttachmentState)
  const setChatAttachment = useSetRecoilState(chatAttachmentState)
  const [chatValue, setChatValue] = useState('');
  const classes = { ...useStyles(), ...baseStyles() }
  const channelState = useRecoilValue(chatChannelState);
  const fileRef = createRef()
  const [messageAttachment, setMessageAttachment] = useState();

  const [messages, setMessages] = useState([]);

  const trackEvent = useTrackEvent()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });


  const BRANCH_API_KEY = process.env.REACT_APP_BRANCH_API_KEY

  const { branchStatus, getBranchIdentity, deepLink, generateDeeplink } = useBranch({
    apiKey: BRANCH_API_KEY,
  })

  useEffect(
    () => {
      generateDeeplink()
    }, []
  );

  useEffect(
    () => {
      setMessages(messageList)

    }, [messageList]
  );

  const handleAttach = useCallback(
    () => {
      if (fileRef.current) {
        fileRef.current.click();
      }
    },
    [fileRef],
  )


  useEffect(
    () => {
      if (chatAttachment) {
        const content = JSON.stringify(chatAttachment, null, 2)
        const convert = new File([content], `error_trace-${moment().format("MM-DD-YYYY-LTS")}.txt`, {
          type: "text/plain",
        });
        setMessageAttachment(convert)
        if (!chatValue) {
          setChatValue('Encountered an error. Please see attached file.')
        }

      }
    }, [chatAttachment]
  );
  const handleUpload = useCallback(
    (file) => {
      setMessageAttachment(file)
    },
    [],
  );

  const theme = useTheme()

  const webkitDocHeight = useDocumentHeight()

  const sendSupportMessageCallback = useCallback(
    async (message) => {
      let payload = null
      let src = source
      
      src = booking?.is_whitelabel ? 'Whitelabel' : 'B2C'
      
      if (booking?.id) {
        payload = {
          data: {
            [`${src} Booking`]: {
              "Frontend": `${src} Patient Web App - ${process.env.VERSION} ${process.env.COMMIT_HASH}`,
              "Partner": booking?.white_label_partner?.label,
              "Schedule": moment(booking?.date_scheduled).format('LL LTS'),
              "Booking Status": parseBookingStatus(booking)?.value,
              "Service": booking?.type?.label,
              "Screen": `${src} - ${location.pathname}`,
              "Device": [deviceData?.os, deviceData?.osName, deviceData?.browserName, deviceData?.browserVersion].filter(t => !isEmpty(t)).join(', '),
              "Appointment": { request_id: booking?.id },
            }
          },
          source: `${src} - ${location.pathname.split(routeMatch.url).filter(t => isEmpty()).join(' ')}`,
        }
      } else {
        payload = {
          data: {
            [`${src} Booking`]: {
              "Frontend": `${src} Patient Web App - ${process.env.VERSION} ${process.env.COMMIT_HASH}`,
              "Screen": `${src} - ${location.pathname}`,
              "Device": [deviceData?.os, deviceData?.osName, deviceData?.browserName, deviceData?.browserVersion].filter(t => !isEmpty(t)).join(', '),
              "Appointment": { request_id: routeMatch?.params?.serviceId },
            },
          },
          source: `${src} ERROR - ${location.pathname.split(routeMatch.url).filter(t => isEmpty()).join(' ')}`,
        }
      }
      setMessageAttachment(false)
      setChatValue('')
      const result = await sendMessageSupportChat(fingerprint, message, messageAttachment, false, payload)
      reloadMessages()
    },
    [booking, fingerprint, location.pathname, messageAttachment, routeMatch?.params?.serviceId, routeMatch.url, source],
  );

  const isSendDisabled = useMemo(
    () => {
      const isEmptyChat = isEmpty(chatValue)
      const isEmptyAttachment = !messageAttachment
      return (isEmptyChat && isEmptyAttachment)
    }, [chatValue, messageAttachment]
  );
  return (
    <>
      <ChatContainer>
        <ConversationHeader>
          <ConversationHeader.Content className={classes.conversationBannerAd}>
            <>
              {appBar}
              <Typography variant="caption" className={classes.title}>
                <FontAwesomeIcon icon={faInfoCircle} fixedWidth /> Be notified when we respond by
                <Link
                  onClick={() => {
                    trackEvent('Chat - download zennya app - opened', { booking_id: serviceId, link: 'app.zennya.com' })
                  }}
                  className={classes.bannerAdLink}
                  href={deepLink}
                >downloading the zennya app</Link>
              </Typography>
            </>
          </ConversationHeader.Content>
        </ConversationHeader>


        <MessageList 
          style={{

            overflowY: 'scroll',
            overflowX: 'hidden',
            height: `calc(${webkitDocHeight}px - 200px)`,

          }} 
          autoScrollToBottom={false}>
          {messages.map((message, index) =>
            <MessageContent message={message} key={index} />
          )}
        </MessageList>

        <div as={MessageInput} style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          borderTop: "1px dashed #d1dbe4",
          marginBottom: "calc(20px + env(keyboard-inset-height))",
        }}>
          <AttachmentButton
            onClick={() => handleAttach()} style={{
              fontSize: "1.2em",
              alignSelf: "flex-start",

            }}> {messageAttachment?.name}</AttachmentButton>
          <div style={{ display: 'flex', flexDirection: 'row', flex: 1, paddingRight: 10 }}>
              <TextField 
                autoFocus
                placeholder='Type message here'
                value={chatValue}
                onChange={e => setChatValue(e.target.value)}
                variant="outlined"
                fullWidth
                size="small"
                color="primary"
                multiline
                maxRows={4}
                style={{
                  margin: theme.spacing(1),
                }}
                InputProps={{
                  style:{
                    padding: theme.spacing(1),
                    fontSize: theme.typography.body2.fontSize,
                  }
                }}
                InputLabelProps={{
                  style: {
                    display: 'none'
                  }
                }}
              />
            <IconButton size="small"
              color='primary'
              onClick={() => {
                sendSupportMessageCallback(chatValue)
              }}
              disabled={isSendDisabled}
            >
              <FontAwesomeIcon icon={faPaperPlane} />
            </IconButton>
          </div>

        </div>
      </ChatContainer>
      <input
        ref={fileRef}
        type="file"
        multiple={false}
        hidden
        accept={(channelState?.attachment_mime_types ?? []).join(',')}
        onChange={(e) => handleUpload(e.target.files[0])}
      />
    </>
  )
}

export { SupportChat };

